import React from 'react';
import { BookOpenIcon } from 'lucide-react';
export const InstitutionalQuote = () => {
  return <section className="py-10 px-4 sm:px-6 lg:px-8 bg-white border-t border-b border-gray-200" data-id="element-253">
      <div className="max-w-4xl mx-auto" data-id="element-254">
        <div className="flex flex-col items-center md:flex-row md:items-start gap-6" data-id="element-255">
          <div className="bg-teal-100 p-3 rounded-full flex-shrink-0" data-id="element-256">
            <BookOpenIcon className="h-8 w-8 text-teal-700" data-id="element-257" />
          </div>
          <div className="text-center md:text-left" data-id="element-258">
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-259">
              Nutricionista Licenciada – Especialista en Nutrición y Bienestar
            </h3>
            <p className="text-gray-700 italic" data-id="element-260">
              "Para la comunidad hispana en Estados Unidos, recomendamos una
              cocina casera simple, con control de porciones y técnicas que
              reduzcan grasas añadidas (como la airfryer), priorizando alimentos
              frescos y variedad nutritiva adaptada a su estilo de vida
              acelerado."
            </p>
          </div>
        </div>
      </div>
    </section>;
};